"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralLinks = void 0;
const gearbox_1 = require("@busy-human/gearbox");
var ReferralLinks;
(function (ReferralLinks) {
    function Defaults() {
        return {
            created: '',
            createdBy: '',
            linkName: '',
            note: '',
            link: '',
            email: '',
            addressedTo: '',
            active: true,
            redeemed: false,
            creditRedeemed: false
        };
    }
    ReferralLinks.Defaults = Defaults;
    class CollectionClass extends gearbox_1.CollectionEntity {
        constructor() {
            super(...arguments);
            this.relationships = {};
        }
        defaults() {
            return Defaults();
        }
    }
    ReferralLinks.CollectionClass = CollectionClass;
    ReferralLinks.Collection = new CollectionClass({ path: '/ReferralLinks' });
})(ReferralLinks = exports.ReferralLinks || (exports.ReferralLinks = {}));
//# sourceMappingURL=index.js.map